import React, {Component} from "react";
import {withStyles} from '@material-ui/core/styles';
import PropTypes from "prop-types";

import Select from './Select';
import {CountryOptions} from '../constants/Countries';
import {FormattedMessage} from "react-intl";

const styles = (theme) => ({

});

class RegionInput extends Component {

  static propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.string,
    disabled: PropTypes.bool,
    countryCode: PropTypes.string,
    onChange: PropTypes.func,
    classes: PropTypes.object,
    children: PropTypes.object,
  };

  static defaultProps = {
    onChange: () => {}
  };

  constructor(props) {
    super(props);
  }

  render() {
    const {countryCode, id, label, value, disabled, onChange, classes, children} = this.props;

    return (
      <Select
        id={id}
        label={<FormattedMessage id={'label.country'}/>}
        onChange={onChange}
        value={value}
        autofill={'country'}
        {...this.props}
        >
        {CountryOptions.map((countryOption) => <option value={countryOption.key}>{countryOption.value}</option>)}
      </Select>
    );
  }
}

export default withStyles(styles)(RegionInput);
